import { useState, type FC } from "react";
import type { ExcelTemplateType } from "./excel-template";
import { getTemplate } from "./excel-template";
import { useExcelTemplate } from "./hooks/useExcelTemplate";

interface Props {
  template: ExcelTemplateType;
  className?: string;
}

const DownloadExcelTemplate: FC<Props> = (props) => {
  const { template, className = "" } = props;
  const { exportFile } = useExcelTemplate();
  const [loading, setLoading] = useState(false);

  const handleDownloadTemplate = async () => {
    setLoading(true);
    await exportFile(getTemplate(template));
    setLoading(false);
  };

  return (
    <button
      type="button"
      className={`btnDownloadTemplate ${className}` }
      onClick={handleDownloadTemplate}
      disabled={loading}
    >
      Vui lòng tải biểu mẫu tại đây
    </button>
  );
};

export default DownloadExcelTemplate;
